import { render } from "./wootJournal.vue?vue&type=template&id=6e767953"
import script from "./wootJournal.vue?vue&type=script&lang=js"
export * from "./wootJournal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__